import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
	MatDialog,
	MatDialogRef,
	MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { List } from 'cypress/types/lodash';
import { ToastrService } from 'ngx-toastr';
import { Denounce } from '../../../core/models/denounce.model';
import { ComplaintsService } from '../../../core/services/complaints.service';
import { UserService } from '../../../core/services/user.service';
import { UtilsService } from '../../../core/services/utils.service';
import { AppState } from '../../../core/state/app.reducer';
import { QS } from '../../../core/utils/quicksort';

@Component({
	selector: 'app-bus-lines-complaints',
	templateUrl: './bus-lines-complaints.component.html',
	styleUrls: ['./bus-lines-complaints.component.scss'],
})
export class BusLinesComplaintsComponent implements OnInit {
	public displayedColumnsDenounces: string[] = ['id', 'date', 'status'];

	loading = true;

	public denounces: any = [];

	private loading$;
	private su: Boolean;
	public line_name: String = '';

	user = {
		phone: '',
		email: '',
		role: '',
		gender: '',
		name: '',
	};

	dataSourceDenounces = new MatTableDataSource<any>(this.denounces);
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

	constructor(
		private store: Store<AppState>,
		public utilsService: UtilsService,
		public dialog: MatDialog,
		private complaintsService: ComplaintsService,
		private toastr: ToastrService,
		private userService: UserService,
		private router: Router,
		public dialogRef: MatDialogRef<BusLinesComplaintsComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {}

	ngOnInit(): void {
		this.getDenouncesByBusLine();
		this.line_name = this.data.line_name;
		this.dataSourceDenounces.paginator = this.paginator;

		this.su = Boolean(localStorage.getItem('superUser'));
		this.getUser();
	}

	getUser(): void {
		this.userService.getSelfUserOp().subscribe((userAtt) => {
			userAtt.UserAttributes.forEach((att) => {
				if (att.Name === 'phone_number') {
					this.user.phone = att.Value;
				} else if (att.Name === 'name') {
					this.user.name = att.Value;
				} else if (att.Name === 'gender') {
					this.user.gender = att.Value;
				} else if (att.Name === 'email') {
					this.user.email = att.Value;
				} else if (att.Name === 'custom:role') {
					this.user.role = att.Value;
				}
			});
			this.loading$ = false;
		});
	}
	navigateComplaintById(complaint_id): void {
		this.closeModal();
		this.router.navigate(['/home/ocurrences-details', complaint_id]);
	}

	closeModal(): void {
		this.dialogRef.close();
	}

	getDenouncesByBusLine(): void {
		this.complaintsService
			.getComplaints({
				paginate: true,
				details: true,
				bus_name: this.data.line_name,
			})
			.subscribe((denounces: any) => {
				this.dataSourceDenounces.data = denounces;
				this.denounces = denounces;
				this.loading = false;
			});
	}
}
